import { ReactNode } from 'react';
import cn from 'classnames';

interface FieldWrapperProps {
  label?: string;
  error?: string;
  showError?: boolean;
  children: ReactNode;
  className?: string;
  fieldId?: string;
  labelAsParagraph?: boolean;
  labelClassName?: string;
}

export const FieldWrapper = ({
  label,
  error,
  showError = false,
  children,
  className,
  fieldId,
  labelAsParagraph = false,
  labelClassName,
}: FieldWrapperProps) => (
  <div className={cn('flex flex-col gap-3 w-full', className)}>
    {label &&
      (labelAsParagraph ? (
        <p
          className={cn(
            'text-base font-medium text-[#454545] leading-[120%] tracking-normal',
            labelClassName,
          )}
        >
          {label}
        </p>
      ) : (
        <label
          htmlFor={fieldId}
          className={cn(
            'text-base font-medium text-[#454545] leading-[120%] tracking-normal',
            labelClassName,
          )}
        >
          {label}
        </label>
      ))}
    {children}
    {showError && error && (
      <p
        id={fieldId ? `${fieldId}-error` : undefined}
        role="alert"
        className="text-red-500 text-[12px]  tracking-normal leading-[1.4]"
      >
        {error}
      </p>
    )}
  </div>
);
